
<template>
  <div class="w-full bg-trader-gray p-2 flex">
    <span class="p-1 w-1/4"> Seitenname:</span>
    <div v-if="!editPageName" class="flex w-full">
      <input readonly="readonly"  data-ui="page-name"  class="border border-trader-input-border p-1 w-full  shadow-inner-2" v-model="pageName">
      <i class="fa-solid fa-pencil ml-1 p-2 bg-trader-dark-gray hover:bg-trader-hover-background hover:text-trader-hover-text hover:cursor-pointer"
         title="bearbeiten" data-ui="edit-PageName" @click="changePageName"></i>
    </div>
    <div v-else class="flex w-full">
      <input class="border border-trader-input-border p-1 w-full  shadow-inner-2" data-ui="new-page-name"  @keyup.enter="editNewPageName" v-model="newPageName">
      <i class="fa-solid fa-check ml-1 p-2 bg-trader-green hover:bg-trader-hover-background hover:text-trader-hover-text text-trader-dark-green hover:cursor-pointer "
         title="speichern" data-ui="save-PageName" @click="editNewPageName()"></i>
      <i class="fa-solid fa-circle-xmark ml-1 p-2 bg-trader-red hover:bg-trader-hover-background text-trader-dark-red hover:text-trader-hover-text hover:cursor-pointer"
         title="abbrechen" @click="changePageName()" data-ui="cancel"></i>
    </div>
  </div>
</template>
<script>
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";

export default {
  name: "CEditPageName",
  props: {
    name: {
      type: String,
      default: ""
    },
    pageId: {
      type: Number,
      required: true
    },
  },
  data() {
    return {
      editPageName: false,
      newPageName: "",
      pageName: this.name
    }
  },
  methods: {
    changePageName() {
      this.editPageName = !this.editPageName;
      this.newPageName = this.pageName;
    },
    async editNewPageName() {
      const mutation = gql`
        mutation editPageName($pageId: Int!, $pageName: String!) {
          editPageName(pageId: $pageId, pageName: $pageName) {
            success
          }
        }
      `;
      try {
        const variables = {
          pageId: this.pageId,
          pageName: this.newPageName
        };
        const {data} = await apolloClient.mutate({mutation, variables});
        this.pageName = this.newPageName;
        this.editPageName = false;
      } catch (error) {
        console.error(error);
      }
    },
  },
  watch: {
    name: function (newVal) {
      this.pageName = newVal;
    }
  }
}
</script>
